<template>
	<!-- Remove "navbar-sticky" class to make navigation bar scrollable with the
    page -->
	<!-- position-fixed top-0 -->
	<!-- d-flex bg-light shadow-sm w-100 bg-white py-1 -->
	<header class="border-bottom" style="z-index: 999;" v-if="hide">
		<div class="container-xl">
			<div class="col d-flex justify-content-center px-0">
				<div class="col-sm-3 d-flex align-items-center" :class="{ 'w-100': data.window[0].value < 576, 'justify-content-start': data.window[0].value > 575 }">
					<nav>
						<div class="container-fluid d-flex align-items-center">
							<span class="pad-x-3 cur-point border-r-1 align-items-center d-flex me-2" style="max-width: 30px;" @click="openwindow()" title="開啟新視窗">
								<span class="d-flex align-items-center font-size-12 text-black-50 mt-1">
									<font-awesome-icon :icon="['fas', 'up-right-from-square']" />
								</span>
							</span>
							<nuxt-link :to="{ name: 'manage' }" class="text-sub fs-4 ps-2 text-decoration-none">旅遊百匯 </nuxt-link>
						</div>
					</nav>
				</div>
				<div class="d-flex ms-auto">
					<button class="btn btn-link text-nowrap" @click="golink(`index`)" v-if="!UserInfo.sort.agency.noFunc.includes(`index`)">回前台</button>
					
					<button type="button" class="btn fs-3 position-relative p-0 me-3" @click="toggleNotify">
						<font-awesome-layers class="fa-fw">
							<font-awesome-icon :icon="['far', 'bell']" />
							<font-awesome-layers-text class="gray8" transform="down-6 right-2  shrink-8" :value="data.message.count" style="background: Tomato;" counter />
						</font-awesome-layers>
					</button>
					<button class="btn position-relative p-0 me-2" type="button" v-if="LoginInfo.status && UserInfo.sort.verify.open.ischeck == 1" @click="toggleNavbar">
						<img :src="UserInfo.image2 || UserInfo.image" alt="" style="width: 2rem;" class="rounded" />
					</button>
					<NuxtLink :to="{ name: 'login' }" v-if="LoginInfo.status && UserInfo.sort.verify.open.ischeck == 0">
						<div class="col-sm-3" :class="{ 'me-4': data.window[0].value < 575 }">
							<span class="fs-2 text-gray-middle opacity-50"><i class="bi bi-person-circle"></i></span>
						</div>
					</NuxtLink>
				</div>
			</div>
			<div class="d-flex col-12 position-relative" v-if="PMessage">
				<div class="ms-auto position-absolute end-0" style="width: 250px;">
					<div class="card">
						<div class="card-header">
							訊息
						</div>
						<ul class="list-group list-group-flush">
							<li class="list-group-item cur-point" v-for="item in PMessageList" @click="openSource(item)" :class="{ 'bg-info bg-opacity-50': item.read == 0 }">
								<div class="d-flex">
									<div class="">
										<span class="border me-1">{{ item.method }}</span
										><small class="text-muted ms-auto">{{ usedayjs(item.createtime, "fromNow") }}</small>
									</div>
								</div>
								<div class="mt-2 d-flex">
									<span>{{ item.title }}</span>
									<button class="ms-auto btn border-0"><font-awesome-icon :icon="['fas', 'chevron-right']" /></button>
								</div>
							</li>
							<li class="list-group-item cur-point border-top text-center">
								<router-link :to="{ name: 'manage-notification' }">顯示全部</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<Teleport to=".Modal__Box">
				<BsModal v-model:show="messageInfo.show">
					<template #header=""> 訊息：{{ messageInfo.title }} </template>
					<template #body="">
						<div>
							<div>內容</div>
							<p>
								{{ messageInfo.content }}
							</p>
						</div>
					</template>
					<template #footer="{ close }">
						<button class="btn btn-danger" @click="close">關閉</button>
					</template>
				</BsModal>
			</Teleport>
			<Teleport to="body">
				<div class="offcanvas offcanvas-end" :style="{ width: data.window[0].value < 450 ? `calc(100% - 3rem)` : `50%` }" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel" v-if="LoginInfo.status">
					<div class="border-bottom col-auto py-3 d-flex bg-main-input">
						<div class="d-flex col-9 align-items-center justify-content-center">
							<div class="col-4 text-center">
								<img :src="UserInfo.image2 || UserInfo.image" alt="" style="width: 3rem;" class="rounded" />
								<!-- <span class="text-main " style="font-size: 3rem;">
							<i class="bi bi-person-circle"></i>
						</span> -->
							</div>
							<div class="col-4 ms-2 pt-1">
								<span class="text-main">{{ UserInfo.agencyName }}</span
								><br />
								<span class="fs-5 fw-bold">{{ UserInfo.name }}</span>
							</div>
						</div>
						<div class="col mt-2">
							<span :class="{ 'text-green fs-6': UserInfo.isVerification == 1 }"
								><i class="bi bi-check2-all"></i><span>{{ UserInfo.isVerification == 1 ? "已認證" : "未認證" }}</span></span
							>
						</div>
					</div>

					<div class="position-absolute bg-white rounded p-1" style="left: -2.8rem; top: 2rem;">
						<button type="button" class="btn-close ms-auto" data-bs-dismiss="offcanvas" aria-label="Close"></button>
					</div>
					<div class="offcanvas-body pt-2 px-0">
						<!-- <ul class="navbar-nav justify-content-end flex-grow-1">
							<li v-for="item in sideList" :key="item.name" class="nav-item border-bottom border-2" @click="ckUrl(item)">
								<div class="nav-link active ps-3 py-3">
									<span class="ps-2 d-flex justify-content-between" style="cursor: pointer;">
										{{ item.name }}
										<span class="me-3"><i class="bi bi-chevron-right"></i></span>
									</span>
								</div>
							</li>
						</ul> -->

						<div class="w-100 px-2">
							<InputBaseInput placeholder="快速搜尋功能" v-model:model="quitsearch" />
							<InputBaseCheckbox class="py-2" v-model:model="data.allshow" :canAll="false" isFill="true" :option="[{ name: data.allshow ? '全部展開' : '全部摺疊', values: data.allshow ? false : true }]"> </InputBaseCheckbox>
						</div>
						<div class="d-flex align-items-center mb-1 w-100">
							<div class="col-12 px-0" :class="{ 'bg-green text-white': data.selectFunc == 'manage-companyOverview' }">
								<router-link class="fs-5 text-decoration-none px-2" @click="selectSideMenu({ url: 'manage-companyOverview' })" :to="{ name: 'manage-companyOverview' }">
									企業總覽
								</router-link>
							</div>
						</div>

						<div v-for="(group, keys) in PbuttonGroup" class="pb-2 px-2" style="line-height: 30px;">
							<div v-if="PmenuBtn[group.values]?.length > 1" style="min-width: 8rem;">
								<div class="d-flex align-items-center cur-point" @click="group.show = !group.show" :class="{ 'text-main': group.show }">
									<span class="fs-5">
										<span class="d-inline-block" style="width: 20px;">
											<span v-if="!group.show"><font-awesome-icon :icon="['far', 'folder']" /></span>
											<span v-else><font-awesome-icon :icon="['far', 'folder-open']" /></span>
										</span>
										<span class="ms-2 d-inline-flex align-items-center">
											{{ group.name }}
											<span class="badge px-2 ms-1 m-small-2" :class="{ 'bg-light text-secondary': !group.show, 'bg-main text-main bg-opacity-25': group.show }">
												{{ PmenuBtn[group.values].length }}
											</span>
										</span>
									</span>
									<span class="ms-auto px-2 cur-point text-gary">
										<font-awesome-icon :icon="['fas', group.show ? 'chevron-up' : 'chevron-down']" />
									</span>
								</div>
								<div>
									<div class="d-flex my-1 bg-light rounded-bottom" v-if="group.show">
										<ul class="list-unstyled mb-0 w-100">
											<li v-for="item in PmenuBtn[group.values]" @click="selectSideMenu(item)" :class="{ 'bg-green': selectMenu(item) }" class="rounded ps-3 py-2 d-flex align-items-center cur-point" style="height: 2.25rem;">
												<span class="me-2 fs-4">
													<i :class="item.icon"></i>
												</span>
												<span class="fs-5">{{ item.name }}</span>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div v-else>
								<div class="" style="height: 2rem;" v-for="item in PmenuBtn[group.values]">
									<div class="fs-4 d-flex align-items-center cur-point ps-1 py-1 ms-n1 me-n1" @click="selectSideMenu(item)" :class="{ 'bg-green rounded': selectMenu(item) }" style="height: 2.25rem; min-width: 10rem;">
										<span class="d-inline-block" style="width: 20px;">
											<i :class="item.icon"></i>
										</span>
										<span class="ms-2 fs-5">{{ item.name }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Teleport>
		</div>
	</header>
</template>
<script>
	import ctrl from "./ts/Head";
	export default ctrl;
</script>
